"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachStylesToNode = function (node, stylesObj) {
    if (node) {
        stylesObj.className
            .split(' ')
            .forEach(function (className) { return node.classList.add(className); });
        Object.keys(stylesObj)
            .filter(function (key) { return key.startsWith('data-'); })
            .forEach(function (key) { return node.setAttribute(key, String(stylesObj[key])); });
    }
};
exports.detachStylesFromNode = function (node, stylesObj) {
    if (node) {
        stylesObj.className
            .split(' ')
            .forEach(function (className) { return node.classList.remove(className); });
        Object.keys(stylesObj)
            .filter(function (key) { return key.startsWith('data-'); })
            .forEach(function (key) { return node.removeAttribute(key); });
    }
};
//# sourceMappingURL=stylableUtils.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/utils/stylableUtils.js
// module id = 1264
// module chunks = 0